<template>
  <b-card v-if="render">
    <b-form class="position-relative">
      <LayoutLoading v-if="itemLoading" />
      <b-row>
        <b-col md="6">
          <b-form-group
            :label="$t('general.name')"
            label-for="page-suggestion-name"
            class="mb-2"
          >
            <b-form-input
              id="page-suggestion-name"
              v-model="form.name"
              readonly
              :state="validateState('name')"
              aria-describedby="input-title-feedback"
            />
            <b-form-invalid
              id="input-name-feedback"
              :label="$t('suggestions.name')"
              :validator="$v.form.name"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('general.email')"
            label-for="page-category-email"
            class="mb-2"
          >
            <b-form-input
              id="page-suggestion-email"
              v-model="form.email"
              readonly
              :state="validateState('email')"
              aria-describedby="input-email-feedback"
            />
            <b-form-invalid
              id="input-email-feedback"
              :label="$t('general.email')"
              :validator="$v.form.email"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('general.phone')"
            label-for="page-suggestion-phone"
            class="mb-2"
          >
            <b-form-input
              id="page-suggestion-phone"
              v-model="form.phone"
              readonly
              :state="validateState('phone')"
              aria-describedby="input-phone-feedback"
            />
            <b-form-invalid
              id="input-phone-feedback"
              :label="$t('suggestions.phone')"
              :validator="$v.form.phone"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            :label="$t('suggestions.message')"
            label-for="page-suggestion-description"
            class="mb-2"
          >
            <b-form-textarea
              id="page-suggestion-description"
              v-model="form.content"
              :state="validateState('content')"
              rows="6"
              aria-describedby="input-content-feedback"
            />
            <b-form-invalid
              id="input-content-feedback"
              :label="$t('general.content')"
              :validator="$v.form.content"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-col
            md="2"
            sm="6"
            cols="12"
          >
            <b-form-group
              :label="$t('suggestions.archive')"
              label-for="suggestion-archive"
              class="mb-2"
            >
              <b-form-checkbox
                id="suggestion-archive"
                v-model="form.archive"
                name="suggestion-archive"
                class="mt-1"
                switch
                inline
              />
            </b-form-group>
          </b-col>
        </b-col>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ isSubmit ? $t("general.isSubmit") : $t("general.update") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="$router.go(-1)"
          >
            {{ $t("general.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BRow,
} from 'bootstrap-vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import Ripple from 'vue-ripple-directive'
import { required, email, minLength } from 'vuelidate/lib/validators'
import useSuggestionsList from './useSuggestionsList'

export default {
  name: 'SuggestionEdit',
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormInvalid,
    BFormTextarea,
    BRow,
    LayoutLoading,
  },
  directives: {
    Ripple,
  },
  computed: {
    itemId() {
      return this.$router.currentRoute.params.id
    },
    render() {
      return this.item ? this.item && Object.keys(this.item).length : true
    },
  },
  created() {
    this.fetchItem(this.itemId)
  },
  validations: {
    form: {
      name: { required, minLength: minLength(3) },
      email: { email },
      phone: { required },
      content: { required },
      archive: {},
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    submitForm() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.sendData()
      }
    },
    sendData() {
      const data = {
        name: this.form.name,
        email: this.form.email,
        phone: this.form.phone,
        content: this.form.content,
        archive: this.form.archive,
      }
      this.updateItem(this.itemId, data, this.form.lang)
    },
  },
  setup() {
    const {
      fetchItem,
      form,
      isSubmit,
      item,
      itemLoading,
      updateItem,
    } = useSuggestionsList()
    return {
      fetchItem,
      form,
      isSubmit,
      item,
      itemLoading,
      updateItem,
    }
  },
}
</script>
